import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../../context/AppContext';
import styles from './Footer.module.css';

/**
 * Site-wide footer with brand blurb, course links, and contact links.
 */
function Footer() {
  const navigate = useNavigate();
  const { setSelectedLevel } = useApp();

  function goJlpt(level) {
    setSelectedLevel(level);
    navigate('/jlpt');
    window.scrollTo({ top: 0 });
  }

  function goContact() {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <div className={styles.brandName}>
            Annie's <span className={styles.sakura}>Class</span>
          </div>
          <div className={styles.contactInfo}>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>📍</span>
              <span>Chung cư Safira Khang Điền, Quận 9, TP.HCM</span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>📱</span>
              <span>Zalo: <a href="tel:0779909495" className={styles.link}>0779909495</a></span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>👥</span>
              <span>Facebook: <a href="https://www.facebook.com/quynhhuong.hongoc" target="_blank" rel="noopener noreferrer" className={styles.link}>Annie Hồ</a></span>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <h5>Khoá học</h5>
          <button onClick={() => { navigate('/toeic'); window.scrollTo({ top: 0 }); }}>TOEIC 400 → 900+</button>
          <button onClick={() => goJlpt('N5')}>JLPT N5 – Sơ cấp</button>
          <button onClick={() => goJlpt('N4')}>JLPT N4 – Sơ trung cấp</button>
          <button onClick={() => goJlpt('N3')}>JLPT N3 – Trung cấp</button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
